import React from "react";
import ChatContainer from "./ChatContainer/ChatContainer";
import SelectionSidebar from "./SelectionSidebar/SelectionSidebar";
import OptionsSidebar from "./OptionsSidebar/OptionsSidebar";
import {
  fetchMessage,
  executeClientAction,
  executeWorkspaceAction,
} from "../conversation";
import { IDLE, IN_PROGRESS, COMPLETED, FAILED } from "../constants";
import trackEvent from "../utils";
import {
  createRunningDetails,
  getRunnerInfo,
  getTotalRunningData,
} from "../api";
import { generateAnswer } from "../api/chatgpt";
import { addDoc } from "firebase/firestore";
import { auth } from "../config/firebase";
import { addMessage } from "../api/firebaseStore";

require("smoothscroll-polyfill").polyfill();

const parseNonGenericResponsesFromBotOutput = (userDefinedObj, genericObj) => {
  console.log("userDefinedObj", userDefinedObj);
  console.log("genericObj", genericObj);

  // // for metarun
  // if (userDefinedObj && userDefinedObj.runninginfo) {
  //   //"getRunnerStatus0"
  //   if (userDefinedObj.runninginfo.request && userDefinedObj.runninginfo.request == 'getRunnerStatus0') {
  //     const r = getRunnerInfo(userDefinedObj.runninginfo.runnerId);
  //     console.log(r);
  //   }
  // }

  const responses = [];
  genericObj.forEach((response) => {
    console.log("response.response_type: ", response.response_type);
    if (response.response_type === "title") {
      responses.push({
        type: "bot",
        content: response.text,
      });
    } else if (response.response_type === "option") {
      // title as first response, skip
      /* responses.push({
        type: 'bot',
        content: response.title,
      }); */

      let preference = "text";
      if (response.preference !== undefined) {
        preference = response.preference;
      }
      const res = {
        type: "option",
        display: "list",
        content: response.options,
        img: userDefinedObj.image,
        title: response.title,
        card: userDefinedObj.card,
        keyword: null,
      };

      // for metarun, update this chat's metarun state
      if (userDefinedObj.runninginfo) {
        res.runninginfo = userDefinedObj.runninginfo;
      }

      if (preference === "button") {
        res.display = "button";
      }
      if (preference === "dropdown") {
        res.display = "dropdown";
      }
      if (userDefinedObj && userDefinedObj.card === "ReportCard") {
        console.log("Option is", res.content);
        res.keyword = userDefinedObj.keyword;
        res.da = userDefinedObj.da;
      }
      if (userDefinedObj && userDefinedObj.card === "PhysiciansReportCard") {
        console.log("Option is", res.content);
        res.specialty = userDefinedObj.specialty;
        res.zip = userDefinedObj.zip;
        res.radius = userDefinedObj.radius || 5;
      }
      responses.push(res);
    } else if (response.response_type === "suggestion") {
      responses.push({
        type: "option",
        display: "button",
        card: "EntryCard",
        img: "http",
        content: response.suggestions,
        title: response.title,
      });
    } else if (response.response_type === "pause") {
      responses.push({
        type: response.response_type,
        time: response.time,
        typing: response.typing,
      });
    } else if (response.response_type === "text") {
      console.log('response.response_type === "text" : ', response.text);
      if (response.text !== "") {
        // 
        if (response.text === "What is the diagnosis?") {
          responses.push({
            type: "autodkw",
            content: response.text,
          });
        } else if (
          response.text === "What kind of specialists are you looking for?"
        ) {
          responses.push({
            type: "autoCompleteSpecialtyInput",
            content: response.text,
          });
        } else if (
          response.text === "Tell us about the medical history"
        ) {
          responses.push({
            type: "MedHistoryInput",
            content: response.text,
          });
        } else if (
          response.text.trim() ===
          "Can you be more specific about your health problem?" || response.text.includes("ask my own question")
          || response.text.includes("What is the question that's bothering you")
        ) {
          // res.inputForGPT = userDefinedObj.InputForGPT;
          responses.push({
            type: "useGPT",
            content: response.text,
            inputForGPT: userDefinedObj.InputForGPT,
          });
        } else if (
          response.text.trim() === "Can you please tell me your location?"
        ) {
          responses.push({
            type: "addressinput",
            content: response.text,
          });
        } else if (
          userDefinedObj &&
          userDefinedObj.card !== null &&
          userDefinedObj.item !== null
        ) {
          responses.push({
            type: "bot",
            content: response.text,
            card: userDefinedObj.card,
            items: userDefinedObj.menu,
          });
        } else {
          responses.push({
            type: "bot",
            content: response.text,
          });
        }
      }
    } else if (response.response_type === "image") {
      responses.push({
        type: "image",
        content: response.source,
      });
    } else if (response.response_type === "search") {
      responses.push({
        type: "bot",
        content: response.header,
      });
      responses.push({
        type: response.response_type,
        content: response.results,
      });
    }
  });
  /* userDefinedObj.forEach((response) => {
    const res = {
      card: null,
      image: null,
    };
    if (response.card === 'EntryCard') {
      res.card = response.card;
    } else if (response.image !== undefined) {
      res.image = response.image;
    }
    responses.push(res);
  }); */
  console.log("responses", responses);
  return responses;
};

const checkForSelectHospitalsIntent = (intents) => {
  for (let i = 0; i < intents.length; i++) {
    console.log('intents[i]', intents[i].intent);
    if (intents[i].intent === "DH_Select_Hospitals" && intents[i].confidence > 0.5) {
      return true;
    }
  }
  return false;
}

const checkForSpecificIntent = (intents, specificIntent) => {
  for (let i = 0; i < intents.length; i++) {
    console.log('intents[i]', intents[i].intent);
    if (intents[i].intent === specificIntent && intents[i].confidence > 0.5) {
      return true;
    }
  }
  return false;
}

class App extends React.Component {
  constructor(props) {
    super(props);

    this.firstCallVal = null;

    this.state = {
      messages: [],
      curBotIntents: null,
      lastMessageJson: JSON.stringify({ test: "hi" }),
      lastMessageContext: {},
      botMessageStatus: IDLE,
      paths: [
        {
          id: 1,
          label: "conversation start",
          description:
            "Utilize buttons and other response types, like photos or bank balances, to help expedite the credit card payment process.",
          path: "conversation start",
        },
        {
          id: 2,
          label: "Book an Appointment",
          description:
            "Provide the required information to schedule an appointment in a flexible, conversational manner.",
          path: "I want to book an appointment",
        },
        {
          id: 3,
          label: "Recommend a Credit Card",
          description:
            "Describe your ideal credit card and receive a recommendation tailored to your preferences.",
          path: "Can you help me choose a credit card?",
        },
      ],
      currentPath: 1,
      notificationText: "",
      notificationLink: null,
      // for metarun
      runninginfo: {},
    };
  }

  componentDidMount() {
    // TODO: wrap in a settimeout of 0
    // this puts it within the event loop
    // so that rendering
    this.firstCallVal = true;
    setTimeout(() => {
      this.routeToPath(this.state.paths[0], this.firstCallVal);
    }, 0);
  }

  displayNotification(notificationText, notificationLink = null) {
    this.setState({ notificationText });
    this.setState({ notificationLink });
  }

  updateChatList(messageObj) {
    const chatList = document.getElementById("chat-list");
    this.setState({ messages: [...this.state.messages, messageObj] }, () => {
      // only scroll when watson responds
      if (messageObj.type !== "user") {
        // add IBM message
        addMessage(auth.currentUser ? auth.currentUser.uid : 'unlogin', auth.currentUser ? auth.currentUser.email : '', "IBM", Date.now(), JSON.stringify(messageObj), '');
        setTimeout(() => {
          // scroll to bottom of #chat-list on each update
          chatList.scroll({ top: chatList.scrollHeight, behavior: "smooth" });
          // IBM Firefox ignores previous scroll()
          // this works. uses scroll-behavior: smooth in css for smooth scrolling
          chatList.scrollTop = chatList.scrollHeight - chatList.clientHeight;
        }, 100);
      }
    });
  }

  iterateResponese(responses, index) {
    if (index < responses.length) {
      const res = responses[index];
      if (res.type !== "pause") {
        this.updateChatList(res);
        if (res.runninginfo) {
          console.log("res.runninginfo: ", res.runninginfo);
          console.log("res all: ", res);
          this.setState({ runninginfo: res.runninginfo });
        }
        this.iterateResponese(responses, index + 1);
      } else {
        const inputField = document.getElementById("input_field");
        if (res.typing) {
          inputField.placeholder = "Haiel is typing...";
        }
        setTimeout(() => {
          inputField.placeholder = "Type here...";
          this.iterateResponese(responses, index + 1);
        }, res.time);
      }
    }
  }

  updateOptionsSidebar(lastMessageJson) {
    this.setState({ lastMessageJson });
  }

  updateConversationContext(lastMessageContext) {
    this.setState({ lastMessageContext });
  }

  updateMessageStatus(botMessageStatus) {
    this.setState({ botMessageStatus });
  }

  botMessageHandler(fullOutputObj) {
    const outputObj = fullOutputObj.result;
    let isNotificationPresent = false;
    let responses = [];
    // check for chat options in generic options object
    if (outputObj.output.generic !== undefined) {
      console.log(outputObj.output);
      responses = responses.concat(
        parseNonGenericResponsesFromBotOutput(
          outputObj.output.user_defined,
          outputObj.output.generic
        )
      );
      if (outputObj.output.intents.length != 0) this.state.curBotIntents = outputObj.output.intents;
      console.log("intents", outputObj.output.intents);
    }

    // execute client programmatic actions if they exist
    if (outputObj.output.actions && outputObj.output.actions.length > 0) {
      console.log(JSON.stringify(outputObj.actions, null, 2));
      const { actions } = outputObj.output;
      actions.forEach((act) => {
        executeClientAction(act).then((result) => {
          if (outputObj.context === undefined) {
            this.sendMessageToConversation(result.result);
          } else if (result.result === "statement") {
            const action = executeWorkspaceAction({
              statement_display: result.dates,
            });
            responses.push(action);
          }
        });
      });
    }

    // execute standard workspace actions if they exist
    if (
      outputObj.output.user_defined !== undefined &&
      outputObj.output.user_defined.action !== undefined
    ) {
      const actionResponseArray = executeWorkspaceAction(
        outputObj.output.user_defined.action
      );

      actionResponseArray.forEach((actionResponse) => {
        if (actionResponse.type !== "notification") {
          responses.push(actionResponse);
        } else {
          isNotificationPresent = true;
          this.displayNotification(actionResponse.text, actionResponse.link);
        }
      });
    }

    // execute standard workspace UI Action if they exist
    if (
      outputObj.output.user_defined !== undefined &&
      outputObj.output.user_defined.ui_action !== undefined
    ) {
      const actionResponseArray = executeWorkspaceAction(
        outputObj.output.user_defined.ui_action
      );

      actionResponseArray.forEach((actionResponse) => {
        if (actionResponse.type !== "notification") {
          console.log(JSON.stringify(actionResponse));
          responses.push(actionResponse);
        } else {
          isNotificationPresent = true;
          this.displayNotification(actionResponse.text, actionResponse.link);
        }
      });
    }
    // serve notification if digression occured
    if (
      !isNotificationPresent &&
      "context" in outputObj &&
      "system" in outputObj.context &&
      "digressed" in outputObj.context.system
    ) {
      this.displayNotification(
        "The virtual assistant is able to answer an unrelated question and return back to the original flow using the Digressions feature."
      );
    }

    this.iterateResponese(responses, 0);
  }

  // for metarun
  runnerRequestHandler(text) {
    if (this.state.runninginfo.runnerId) {
      console.log("runnerRequestHandler: ", text);
      // console.log('userMessageHandler: ', this.state.runninginfo);
      // console.log('userMessageHandler: ', text);
      // console.log('userMessageHandler: ', text == 'Milage data correct! Thank you!');
      // createRunningDetails
      if (
        text == "Milage data correct! Thank you!" &&
        this.state.runninginfo.mileage &&
        this.state.runninginfo.duration
      ) {
        console.log("createRunningDetails: before ", this.state.runninginfo);
        createRunningDetails(this.state.runninginfo);
        console.log("createRunningDetails: after ", this.state.runninginfo);
      }
    }
  }

  async userMessageHandler(type, text, intents) {
    const originalText = text;
    this.runnerRequestHandler(text);
    trackEvent("Sent Message", "TextInput", "Chat TextInput");
    // do not accept empty inputs
    if (text.trim() !== "") {
      // console.log("lastMessageJson ",this.state.lastMessageJson);
      // add user message to state
      if (true) {
        console.log("User input displayed");
        this.updateChatList({
          type: "user",
          content: text,
        });
      }
      if (checkForSpecificIntent(intents, "DH_Select_HospitalsAAA")) {
        const answer = await generateAnswer(
          "Extract the information from the following text: asking for {myself/someone else}, {male/female}, {age}. "
          + "Only return words of the information you extracted e.g. myself male 19-years-old. \n"
          + text);
        if (answer.error && answer.error.message) {
          console.error(answer.error.message);
        } else {
          text = answer.data.result;
        }
        console.log("GPT info (DH_Select_Hospitals):", text);
      }
      if (this.state.lastMessageJson.includes("Tell us about the medical history")) {
        const answer = await generateAnswer(
          "Disclose medical history from the following text, the format should be like: 'Medical History: the symptom last for {a few days/a few weeks/for months/more than a year}, the patient treated: {yes/no}, the condition is getting {better/worse/the same} and next appointment is in {a few days/a few weeks/months/no appointment}'"
          // + "Only return words of the information you extracted e.g. the symptom last for a few days, is not treated, the condition is getting better,next appointment is in a few weeks. \n"
          + "\n\n"
          + text);
        if (answer.error && answer.error.message) {
          console.error(answer.error.message);
        } else {
          text = answer.data.result;
        }
        console.log("GPT info (DH_Diagnosed):", text);
      }
      const finalText = text;
      await addMessage(auth.currentUser ? auth.currentUser.uid : 'unlogin', auth.currentUser ? auth.currentUser.email : '', "user", Date.now(), originalText, finalText === originalText ? '' : finalText);
      this.sendMessageToConversation(text, this.state.lastMessageContext);
    }
  }

  routeToPath(path, firstCallVal) {
    trackEvent("Navigated to Panel", "Button", "NavButton");
    this.setState({ messages: [] });
    this.setState({ currentPath: path.id });
    this.setState({ lastMessageContext: {} });
    if (!firstCallVal) {
      this.firstCallVal = true;
    }
    // send two requests to conversation chained together
    // the fetchMessage call clears the existing context
    // the sendMessageToConversation call sets the context to the selected
    // path.
    // fetchMessage is called with clearSession = true to generate a new session
    // and prevent issues with the conversations
    fetchMessage("", null, this.firstCallVal, true, (err, data) => {
      if (data) {
        this.updateConversationContext(data.context);
        this.sendMessageToConversation(
          path.path,
          this.state.lastMessageContext
        );
      }
    });
  }

  sendMessageToConversation(text, context = null) {
    this.updateMessageStatus(IN_PROGRESS);

    fetchMessage(text, context, this.firstCallVal, false, (err, data) => {
      // data.code is set for an error response
      console.log("Conversation log", data);
      if (err || data.code !== undefined) {
        this.updateMessageStatus(FAILED);

        this.updateChatList({
          type: "bot",
          content:
            "I'm having trouble connecting to the server, please refresh the page.",
        });

        const errorMsg = err || data;

        throw new Error(errorMsg);
      }

      console.log("sendMessageToConversation data: ", data);

      const user_defined = data.result.output.user_defined;

      // for metarun
      if (user_defined && user_defined.runninginfo) {
        console.log("for metarun");
        //"getRunnerInfo"
        if (
          user_defined.runninginfo.request &&
          user_defined.runninginfo.request == "getRunnerStatus0"
        ) {
          //console.log('for metarun getRunnerInfo');
          getRunnerInfo(user_defined.runninginfo.runnerId).then((runData) => {
            console.log("runData: ", runData.data);
            data.result.output.generic[0].text =
              `Thank you for all the information! ${runData.data.cnName} ${runData.data.university} ${runData.data.alumni} | ` +
              `Total Mileage: ${runData.data.totalMileage} miles | Total Duration: ${runData.data.totalDuration} minutes`;

            this.updateAllRest(data);
          });
        }
        //getTotalRunningData
        else if (
          user_defined.runninginfo.request &&
          user_defined.runninginfo.request == "getTotalRunningData"
        ) {
          console.log("for metarun getTotalRunningData");
          getTotalRunningData().then((runData) => {
            //console.log('for metarun getTotalRunningData: ', runData);
            //console.log('for metarun getTotalRunningData to set: ', data.result.output.generic);
            data.result.output.generic[2].text =
              `2023 ZJU Crossing Europe MetaRun:  Started on 05/07 | ` +
              `Total Mileage: ${runData.data.totalMileage} miles | Total Duration: ${runData.data.totalDuration} minutes | Runners Reported: 320. ` +
              `Event Status: Keep calm and carry on!`;
            this.updateAllRest(data);
          });
        } else {
          this.updateAllRest(data);
        }
      } else {
        this.updateAllRest(data);
      }
    });
  }

  updateAllRest(data) {
    // update message status
    this.updateMessageStatus(COMPLETED);
    // render appropriate data
    this.botMessageHandler(data);
    // send stringified JSON to sidebar
    this.updateOptionsSidebar(JSON.stringify(data));
    // update context
    this.updateConversationContext(data.result.context);
  }

  render() {
    return (
      <div className="ibm App">
        {/*
        <SelectionSidebar
          onPathSelect={(path) => { this.routeToPath(path); }}
          paths={this.state.paths}
          currentPath={this.state.currentPath}
        />
        */}
        <ChatContainer
          resetBot={() => {
            this.setState({
              messages: []
            })
            this.routeToPath(this.state.paths[0], this.firstCallVal);
          }}
          messages={this.state.messages}
          chatOptions={this.state.chatOptions}
          onUserInput={(type, text) => {
            this.userMessageHandler(type, text, this.state.curBotIntents);
          }}
          botMessageStatus={this.state.botMessageStatus}
        />
        {/*
        <OptionsSidebar
          json={this.state.lastMessageJson}
          paths={this.state.paths}
          currentPath={this.state.currentPath}
          onPathSelect={(path) => { this.routeToPath(path); }}
          notificationText={this.state.notificationText}
          notificationLink={this.state.notificationLink}
        />
        */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js